export enum LegalDocumentTypeEnum {
    Privacy = 'privacy',
    Terms = 'terms',
}
